class DualRangeSlider {
  constructor(rangeElement) {
    this.range = rangeElement;
    this.min = Number(rangeElement.dataset.min);
    this.max = Number(rangeElement.dataset.max);
    this.handles = [...this.range.querySelectorAll('.handle')];
    this.startPos = 0;
    this.activeHandle = null;

    // Add event listeners for mouse and touch events
    this.handles.forEach((handle) => {
      handle.addEventListener('mousedown', this.startMove.bind(this));
      handle.addEventListener('touchstart', this.startMoveTouch.bind(this));
    });

    window.addEventListener('mouseup', this.stopMove.bind(this));
    window.addEventListener('touchend', this.stopMove.bind(this));
    window.addEventListener('touchcancel', this.stopMove.bind(this));
    window.addEventListener('touchleave', this.stopMove.bind(this));

    this.initializeHandles();
  }

  initializeHandles() {
    const rangeRect = this.range.getBoundingClientRect();
    const handleRect = this.handles[0].getBoundingClientRect();
    this.range.style.setProperty('--x-1', '0px');
    this.range.style.setProperty('--x-2', rangeRect.width - handleRect.width / 2 + 'px');
    this.handles[0].dataset.value = this.range.dataset.min;
    this.handles[1].dataset.value = this.range.dataset.max;
  }

  startMoveTouch(e) {
    const handleRect = e.target.getBoundingClientRect();
    this.startPos = e.touches[0].clientX - handleRect.x;
    this.activeHandle = e.target;
    window.addEventListener('touchmove', this.moveTouch.bind(this));
  }

  startMove(e) {
    this.startPos = e.offsetX;
    this.activeHandle = e.target;
    window.addEventListener('mousemove', this.move.bind(this));
  }

  moveTouch(e) {
    this.move({ clientX: e.touches[0].clientX });
  }

  move(e) {
    const isLeft = this.activeHandle.classList.contains('left');
    const property = isLeft ? '--x-1' : '--x-2';
    const parentRect = this.range.getBoundingClientRect();
    const handleRect = this.activeHandle.getBoundingClientRect();
    let newX = e.clientX - parentRect.x - this.startPos;

    if (isLeft) {
      const otherX = parseInt(this.range.style.getPropertyValue('--x-2'));
      newX = Math.min(newX, otherX - handleRect.width);
      newX = Math.max(newX, 0 - handleRect.width / 2);
    } else {
      const otherX = parseInt(this.range.style.getPropertyValue('--x-1'));
      newX = Math.max(newX, otherX + handleRect.width);
      newX = Math.min(newX, parentRect.width - handleRect.width / 2);
    }

    const newValue = this.calcHandleValue((newX + handleRect.width / 2) / parentRect.width);
    this.activeHandle.dataset.value = newValue;

    // Update the position of the handle
    this.range.style.setProperty(property, newX + 'px');
    this.updateInputValues();
  }

  calcHandleValue(percentage) {
    return Math.round(percentage * (this.max - this.min) + this.min);
  }

  stopMove() {
    window.removeEventListener('mousemove', this.move);
    window.removeEventListener('touchmove', this.moveTouch);
    this.activeHandle = null; // Reset activeHandle to ensure it stops moving
  }

  updateHandles() {
    const minValue = Number(this.handles[0].dataset.value);
    const maxValue = Number(this.handles[1].dataset.value);
    this.updateHandlePosition(minValue, maxValue);
  }

  updateHandlesFromInput(value, type) {
    const newValue = Math.max(this.min, Math.min(this.max, Number(value)));

    if (type === 'min') {
      this.handles[0].dataset.value = newValue;
    } else {
      this.handles[1].dataset.value = newValue;
    }

    this.updateHandlePosition(Number(this.handles[0].dataset.value), Number(this.handles[1].dataset.value));
    this.updateInputValues();
  }

  updateHandlePosition(minValue, maxValue) {
    const minX = ((minValue - this.min) / (this.max - this.min)) * 100;
    const maxX = ((maxValue - this.min) / (this.max - this.min)) * 100;

    this.range.style.setProperty('--x-1', `${minX}%`);
    this.range.style.setProperty('--x-2', `${maxX}%`);
  }

  updateInputValues() {
    document.querySelector('.min_price').value = this.handles[0].dataset.value;
    document.querySelector('.max_price').value = this.handles[1].dataset.value;
  }
}